export class CommonConstants {
  static PHONE_VALIDATION_REGEX = /^0\d{9,10}$/;
  static BIRTHDAY_VALIDATION_REGEX = /^(\d{4})[-/](\d{2})[-/](\d{2})$/;
  static FORMAT_PHONE_VALIDATION_REGEX = /^(?!0800)\b(?:090|080|070|060)\d{8}$|^020(?:\d{11}|\d{8})$/;
  static KATAKANA_VALIDATION_REGEX = /^([ァ-ヶー\s]+)$/;
  static HIRAGANA_VALIDATION_REGEX = /[^ぁ-ん]+/g;
  static NUMBER_VALIDATION_REGEX = /[^0-9]/g;
  static FORMAT_TEXT_DOWN_LINE = /(?:\r\n|\r|\n)/g;
  static ALPHABET_NUMERIC_VALIDATION_REGEX = /^(([a-zA-Z0-9]))*$/;
  static ZIPCODE_VALIDATION_REGEX = /^\d{7}$/;
  static ONLY_APHABET_HALFSIZE = /[^a-zA-Z0-9-!@#$%^&._"'()+,/;<>=|?[\]\\`~{}]/g;
  static STRIP_TAGS = /(<([^>]+)>)/gi;
  static SPACE_REGEX = /\s/g;
  static COMMA_REGEX = /,/g;
  static SLASH_REGEX = /[/]/g;
  static HASH_REGEX = /#/g;
  static BASE64_REGEX = /^[A-Za-z0-9+/=]+$/;
  // REGEX PHONE NUMBER
  static NUMBER_PHONE_FORMAT_LONG = 'NNN-NNNN-NNNN';
  static NUMBER_PHONE_FORMAT_SHORT_A = 'NN-NNNN-NNNN';
  static NUMBER_PHONE_FORMAT_SHORT_B = 'NNN-NNN-NNNN';
  static NUMBER_PHONE_FORMAT_SHORT_C = 'NNNN-NN-NNNN';
  static NUMBER_PHONE_FORMAT_SHORT_D = 'NNNNN-N-NNNN';
  static ZIPCODE_FORMAT = 'NNN-NNNN';
  static DATE_FORMAT = 'yyyy年M月d日';
  static DATE_FORMAT_CUSTOM = 'yyyy/MM/dd';
  static DATETIME_FORMAT_SPECIFIC = 'yyyy/MM/dd HH:mm';
  static DATETIME_WITHOUT_YEAR_FORMAT = 'MM/dd H:mm';
  static DATETIME_FORMAT = 'yyyy年M月d日 H:mm';
  static DATETIME_FORMAT_CUSTOM = 'yyyy/MM/d H:mm:ss';
  static DATE_FORMAT_DASH = 'yyyy-MM-dd';
  static DATE_VALIDATION_REGEX = /^\d{4}-\d{2}-\d{2}$/;
  // REGEX POINT NUMBER
  static STRING_REGEX = /\D/g;
  static COMMA_NUMBER_REGEX = /\B(?=(\d{3})+(?!\d))/g;
  // eslint-disable-next-line no-useless-escape
  static SPECIAL_CHAR = /\D/g;
  static GENDERS = [
    { value: 'male', label: '男性' },
    { value: 'female', label: '女性' },
    { value: 'other', label: 'その他' },
  ];
  static LOADING_TIME = 300;
  static BACKSPACE_KEYCODE = 8;
  // pattern
  static NUMBER_PATTERN = '\\d*';
  // eslint-disable-next-line no-useless-escape
  static ALPHANUMSPECIAL_VALIDATION_REGEX = /(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[`~!@#$%^&*()\-_+=\[\]{}:;'"\|<>,.?])([a-zA-Z0-9`~!@#$%^&*()\-_+=\[\]{}:;'"\|<>,.?]+)$/;
  // eslint-disable-next-line no-useless-escape
  static ALPHANUM_AND_SPECIAL_VALIDATION_REGEX = /(?=.*[a-zA-Z])(?=.*[0-9])([a-zA-Z0-9`~!@#$%^&*()\-_+=\[\]{}:;'"\|<>,.?]+)$/;
  static EMOJI_REGEX = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/g;
  static URL_PATTERN = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-z]{2,}(:\d{2,5})?(\/[^\s]*)?$/;
  static ALPHANUMERIC_PATTERN = /^[a-zA-Z0-9]+$/;
  static URL_VALIDATION = /https?:\/\/[^\s<>"]+/g;
  static IS_SAME_DIGITS = /^(\d)(?!\1+$)\d{5}$/;
  static URL_ERROR_FORMAT = /(\?|&)error=[^&]*(&|$)/;
  static typeOfficial = 1;
  static typeShop = 2;
  static typeDuplicate = 'DUPLICATE';
  static typeError = 'ERROR';
  static typeErrorAddress = 'ERROR_ADDRESS';
  static CHARGE_PROCESSING_STATUS = 2;
  static civilios = 1;
  static xID = 2;
  static digital = 3;
  static NUMBER = '0123456789';
  static typeEmail = 1;
  static typeSms = 2;
  static typeSoundApp = 2;
  static typePhone = 3;
  static nativeType = 1;
  static appType = 2;
  static CHARGE_TYPE = {
    CREDIT_CARD: 1,
    CONBINI: 2,
    PAY_EASY: 3,
    BANK: 4,
    STORE: 5,
  };
  static LIMIT_WITH_MAXLENGTH = 999999;
  static MAXIMUM_CHARGE = {
    [this.CHARGE_TYPE.CREDIT_CARD]: 9999999,
    [this.CHARGE_TYPE.CONBINI]: 299999,
    [this.CHARGE_TYPE.PAY_EASY]: 999999,
  };
  static IS_CONVENIENCE_STORE = 'CONVENIENCE_STORE';
  static STATUS_CHARGE = {
    'WAITING' : '入金待ち',
    'CANCEL'  : 'キャンセル',
    'DONE'    : '入金',
    'TICKET_DONE': '購入',
  };
  static TOKEN_CODE = {
    SUCCESS: '000',
  };
  static CARD_BRAND = {
    VISA: 'icon-card-visa',
    MASTER: 'icon-card-master',
    JCB: 'icon-card-jcb',
    AMEX: 'icon-card-amex',
    DINERS: 'icon-card-diners',
    NO_CREDIT_CARD: 'icon-no-credit-card',
  };
  static PAYMENT_TYPE = {
    _3DS: 0,
    _3DS2: 2,
  };
  static COLORS_GIFT_CARD = [
    '#F74458',
    '#EF7B26',
    '#FFB62C',
    '#ADDB15',
    '#4DC45B',
    '#55C6B0',
    '#4EB9E0',
    '#5B82EA',
    '#9E70DD',
    '#C974D3',
    '#F06998',
    '#C7AA2E',
    '#BABABA',
    '#B9775A',
    '#838383',
    '#6D8634',
    '#0C4A3E',
    '#252871',
    '#520707',
    '#2B2B2B',
  ];
  static TEXT_COLOR_TICKET = {
    0: '#fff',
    1: '#000',
    2: '#6198F0',
    3: '#FFB62C',
    4: '#4DC45B',
  };
  static GIFT_CARD_MIN_LENGTH = 3;
  static GIFT_CARD_MAX_LENGTH = 20;
  static OPACITY_LEVEL = {
    11: 0.05,
    16: 0.08,
    19: 0.2,
    20: 0.32,
  };
}

export class ChargeConstants {
  static STATUS = {
    IS_PROCESSING: 5,
    IS_WAITING_3DS2: 2
  };
}

export class EventConstants {
  static status = {
    paused: { value: 5, label: '一時停止' },
    expired: { value: 3, label: '期間終了' },
    open: { value: 2, label: '公開中' },
    achieved: { value: 4, label: '予算達成' },
    prepared: { value: 1, label: '準備中' }
  };
  static type = {
    gift: 1,
    charge: 2,
    payment: 3,
    chargeTicket: 4,
    paymentTicket: 5,
  };
}

export class HistoryConstants {
  static type = {
    charge: 'Charge',
    payment: 'Payment',
    register: 'Register',
    registerCPM: 'RegisterCPM',
  };
  static exportCsvStatus = {
    waiting: 0,
    success: 1,
    cancel: 9,
  };
  static paymentType = {
    manual: { value: 'manual', label: '手動利用' },
    own: { value: 'own', label: '会員本人による支払い' },
    cancel: { value: 'cancel', label: '取り消し' },
    issuerCancel: { value: 'issuerCancel', label: '取り消し'},
    expired: { value: 'expired', label: '有効期限切れ' },
  };
  static chargeType = {
    manual: { value: 'manual', label: '手動発行' },
    own: { value: 'own', label: '会員本人によるチャージ' },
    issuer: { value: 'issuer', label: '取り消し'},
    shop: { value: 'shop', label: '取り消し'},
  };
  static chargeTypeName = {
    payeasy: '銀行振込（Pay-easy）',
    conbini: 'コンビニ払い',
    creditCard: 'クレジットカード',
  };
}

export class MimamoriConstants {
  static status = {
    pending: 'pending',
    approved: 'approved',
  };
  static locked = 'locked';
  static maxAcount = 5;
}

export class PointConstants {
  static type = {
    paymentPoint: { value: 0, label: '支払付与'},
    chargePoint: { value: 1, label: '' },
    qrPoint: { value: 2, label: 'QR付与'},
    manualPoint: { value: 3, label: '手動付与'},
    registMember: { value: 4, label: '会員登録付与' },
    totalPayment: { value: 5, label: '支払消費'},
    totalQr: { value: 6, label: 'QR消費'},
    totalManual: { value: 7, label: '手動消費'},
    cancel: { value: 8, label: 'キャンセル'},
    relaxPoint: { value: 9, label: '失効ポイント'},
    cancelPoint: { value: 10, label: '取り消し' },
    plannedPoint: { value: 11, label: ''},
  };
}

export class VerificationTypes {
  static type = {
    no: { label: '認証無し', value: 0 },
    identity: { label: '本人確認必須', value: 1 },
    sms: { label: 'SMS認証必須', value: 2 },
    both: { label: '本人確認＆SMS認証必須', value: 3 },
  };
}
